import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const BlocksDailyReport = lazy(() => import('./BlocksDailyReport'));

const BlocksDailyReportConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.top,
  routes: [
    {
      path: 'apps/skud/blocks-daily-report',
      element: <BlocksDailyReport />,
    },
  ],
};

export default BlocksDailyReportConfig;
